<template>
  <v-container
    id="incendiosList"
    class="ml-3"
    :class="{'mobile': $vuetify.breakpoint.xs}"
    :show="showIncendiosCards"
    :style="{
      marginTop: (isSimulacionCollapsed) ? '30px' : '0px',
      transition: 'margin-top 0.3s ease'
    }"
  >
    <v-row dense class="mb-3">
      <v-col cols="3">
        <v-btn block :color="getColor(1)" @click="filtroSeleccionado = 1">24h</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn block :color="getColor(2)" @click="filtroSeleccionado = 2">48h</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn block :color="getColor(3)" @click="filtroSeleccionado = 3">72h</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn block :color="getColor(4)" @click="openCalendar">
          <v-icon>mdi-calendar</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="showCalendar" max-width="350px" persistent content-class="custom-calendar-dialog">
      <v-card>
        <v-card-title class="text-center">Selecciona un rango de fechas</v-card-title>
        <v-card-text class="d-flex justify-center">
          <v-date-picker v-model="fechaSeleccionadaTemp" range @change="filtrarPorFecha" />
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="showCalendar = false">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="list-scroll">
      <v-row dense v-for="incendio in incendiosReducedFiltered" :key="incendio.ID_INCENDIO">
        <v-col>
          <v-card :color="getCardColor(incendio)" elevation="6" dark @click="selectIncendio(incendio)">
            <v-card-title class="text-h7 pt-0 pl-3">
              {{ incendio.NOMBRE ? incendio.NOMBRE : incendio.LOCALIDAD }}
              <v-spacer />
            </v-card-title>
            <v-card-subtitle :class="{'text-right': $vuetify.breakpoint.smAndUp, 'pb-0': true}">
              {{ getCardDate(incendio) | formatDate }}
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import * as ArcGIS from '@/helpers/ArcGIS.js'

export default {
  props: {
    showIncendiosCards: Boolean,
    isSimulacionCollapsed: Boolean
  },

  data: () => ({
    showCalendar: false,
    filtroIncendios: [],
    filtroSeleccionado: 1,
    fechaSeleccionada: null,
    fechaSeleccionadaTemp: null
  }),
  computed: {
    ...mapGetters('incendio', ['incendiosReducedFiltered'])
  },
  watch: {
    filtroSeleccionado () { this.filterEmergencies() }
  },
  mounted() { this.filterEmergencies() },
  methods: {
    getCardColor (inc) {
      const n0 = inc?.NIVELES?.[0]
      const e0 = inc?.ESTADOS?.[0]
      if (n0 && !n0.FECHA_FIN) return n0?.TIPO_INCENDIO_NIVEL?.COLOR || 'primary'
      if (e0) return e0?.TIPO_INCENDIO_ESTADO?.COLOR || 'primary'
      return 'lightGray'
    },
    getCardDate (inc) {
      const e0 = inc?.ESTADOS?.[0]
      return e0?.FECHA || inc?.FECHA_CREACION || null
    },
    openCalendar() {
      this.fechaSeleccionadaTemp = this.fechaSeleccionada
      this.showCalendar = true
    },
    resetFechas() { this.fechaSeleccionada = null },
    getColor(tab) { return tab === this.filtroSeleccionado ? 'success' : 'primary' },
    selectIncendio(incendio) {
      this.$emit('selectIncendio', incendio.ID_INCENDIO)
    },
    filtrarPorFecha () {
      if (this.fechaSeleccionadaTemp) {
        this.fechaSeleccionada = this.fechaSeleccionadaTemp
        this.showCalendar = false
        if (this.filtroSeleccionado !== 4) this.filtroSeleccionado = 4
        else this.filterEmergencies()
      }
    },
    filterEmergencies() {
      let ini, fin
      if (this.filtroSeleccionado === 4 && this.fechaSeleccionada?.length === 2) {
        ini = new Date(this.fechaSeleccionada[0])
        fin = new Date(this.fechaSeleccionada[1])
        if (ini > fin) [ini, fin] = [fin, ini]
      } else {
        const horas = this.filtroSeleccionado === 1 ? 24 : this.filtroSeleccionado === 2 ? 48 : 72
        fin = new Date()
        ini = new Date(fin)
        ini.setHours(fin.getHours() - horas)
      }
      this.$store.dispatch('incendio/setFiltro', [ini, fin])
      ArcGIS.redrawIncendios()
    }
  }
}
</script>

<style scoped>
#incendiosList {
  position: absolute;
  top: 20px;
  width: 300px;
  max-height: calc(100% - 75px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mobile {
  top: 65px !important;
  width: 170px !important;
}

.list-scroll {
  overflow-x: hidden;
}

::-webkit-scrollbar { width: 0px; }
</style>
